import { AuthService } from 'app/_services/auth.service';
import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('AuctionBidCtrl', AuctionBidCtrl);

    /**
     * Auction Bid includes auction detail and auction bidding.
     *
     * @author flzemke.btc
     * @ngInject
     */
    function AuctionBidCtrl(
        $routeParams,
        auctionResource,
        auctionsOverviewService,
        authService: AuthService,
        DATES,
        activitiesService
    ) {
        var vm = this;

        var ORDER_CURVE = {
            price: {
                value: '',
                unit: 'cent/kWh/h/Runtime'
            },
            quantity: {
                value: '',
                unit: 'kWh/h'
            }
        };

        vm.MINIMUM_BID_INFO_BLAH =
            auctionsOverviewService.MINIMUM_BID_INFO_BLAH;
        vm.DATES = DATES;
        vm.PAGE = auctionsOverviewService.PAGE;
        vm.ACTION_TYPE = auctionsOverviewService.ACTION_TYPE;
        /** @type {boolean} */ vm.isLoggedIn = null;
        vm.auction = {};
        vm.bidForm = {};
        /** @type {Object} */ vm.config = null;
        vm.auctionId = $routeParams.auctionId;
        vm.detailPage = $routeParams.bidOrDetails === 'details';
        vm.uiLoadingAuction = true;
        vm.uiLoadingAuctionError = false;
        /**
         * This will be set based on {@link hasValidBiddingCurve}.
         *
         * @type {boolean}
         */
        vm.uiMissingBiddingCurve = false;
        vm.uiSubmitAuctionSuccess = null;
        vm.uiSubmitAuctionError = null;
        vm.uiSubmitAuctionErrorMsg = null;
        vm.uiCheckPage = false;
        vm.bid = { orderCurve: [] };
        vm.smallAndLargePriceSteps = {};
        vm.addAnotherSurcharge = addAnotherSurcharge;
        vm.submitBid = submitBid;
        vm.onAnyAmountChange = onAnyAmountChange;
        vm.onUndiscountedChange = onUndiscountedChange;
        vm.orderCurveMinQuantity = {};
        vm.orderCurveMaxQuantity = {};
        vm.undiscounted = false;

        (function init() {
            authService.userLoginPromise.promise
                .then((loggedInUser) => {
                    vm.isLoggedIn = !!loggedInUser;
                })
                .catch(() => {
                    vm.isLoggedIn = false;
                });

            addAnotherSurcharge();

            auctionResource.get(
                { auctionId: vm.auctionId },
                function (res) {
                    vm.auction = res;
                    vm.uiLoadingAuction = false;
                    if (res.algorithmType === 'LONG_TERM') {
                        vm.smallAndLargePriceSteps =
                            activitiesService.getSmallAndLargePriceSteps(
                                res.auctionWindow
                            );
                    }
                },
                function () {
                    vm.uiLoadingAuction = false;
                    vm.uiLoadingAuctionError = true;
                }
            );

            auctionResource.config(
                { auctionId: vm.auctionId },
                function (res) {
                    vm.config = res;
                },
                function () {
                    vm.uiLoadingAuction = false;
                    vm.uiLoadingAuctionError = true;
                }
            );
        })();

        /**
         * Submit the form and send a request to the back-end if validation succeeded
         * and {@link vm.uiCheckPage} is true.
         *
         * @param {boolean} isValid A boolean representing the validation of the form.
         * @returns {boolean} true if a call to the back-end service was made, false otherwise.
         */
        function submitBid(isValid) {
            vm.uiMissingBiddingCurve = !hasValidBiddingCurve();
            if (!isValid || vm.uiMissingBiddingCurve) {
                return false;
            }
            if (!vm.uiCheckPage) {
                vm.uiCheckPage = true;
                return false;
            }

            auctionResource.bidLongTerm(
                { auctionId: vm.auctionId },
                vm.bid,
                function () {
                    vm.uiSubmitAuctionSuccess = true;
                },
                function (res) {
                    vm.uiSubmitAuctionError = true;
                    vm.uiSubmitAuctionErrorMsg = res.data.message;
                }
            );

            return true;
        }

        /**
         * Check if there is a valid bidding curve in {@link vm.bid.orderCurve}.
         * A valid bidding curve for now is nothing more than one with non-empty price and quantity values.
         *
         * @returns {boolean} true if there is a bidding curve with non-empty price and quantity values,
         *  false otherwise.
         */
        function hasValidBiddingCurve() {
            for (var i = 0; i < vm.bid.orderCurve.length; i++) {
                if (
                    vm.bid.orderCurve[i].price.value &&
                    vm.bid.orderCurve[i].quantity.value
                ) {
                    return true;
                }
            }
            return false;
        }

        function addAnotherSurcharge() {
            vm.bid.orderCurve.push(angular.copy(ORDER_CURVE));
        }

        /**
         * Reacts upon changes on amount fields in the pkpYourBiddingCurve directive.
         *
         * @param {Object[]} orderCurve
         * @returns {void}
         */
        function onAnyAmountChange(orderCurve) {
            var minAndMaxQuantities =
                auctionsOverviewService.findMinAndMaxQuantities(orderCurve);
            vm.orderCurveMinQuantity = minAndMaxQuantities.minQuantity;
            vm.orderCurveMaxQuantity = minAndMaxQuantities.maxQuantity;
        }

        /**
         * Reacts upon changes of undiscounted checkbox in the pkpYourBiddingCurve directive.
         *
         * @param {Object[]} undiscounted
         * @returns {void}
         */
        function onUndiscountedChange(undiscounted) {
            vm.undiscounted = undiscounted;
        }
    }
})();
